// 判断棋子移动/吃子是否符合规则
let mark: any = {}
let role = ''
export const isConformRule = (
  chess: string,
  sx: number,
  sy: number,
  ex: number,
  ey: number,
  transMap: any[][],
) => {
  console.log('判断走棋合法性', chess, sx, sy, ex, ey)
  mark = transMap
  const _chess = chess.toUpperCase()
  role = _chess === chess ? 'w' : 'b' // “w”表示红方，“b”表示黑方。
  switch (chess.toUpperCase()) {
    case 'R': //车
      if (rookRule(sx, sy, ex, ey)) return true
      else return false
    case 'C': //炮
      if (cannonRule(sx, sy, ex, ey)) return true
      else return false
    case 'N': //马
      if (knight(sx, sy, ex, ey)) return true
      else return false
    case 'B': //象
      if (bishopRule(sx, sy, ex, ey)) return true
      else return false
    case 'A': //士
      if (guard(sx, sy, ex, ey)) return true
      else return false
    case 'K': //将帅
      if (kingRule(sx, sy, ex, ey)) return true
      else return false
    case 'P': //兵
      if (pawnRule(sx, sy, ex, ey)) return true
      else return false
  }
  return true
}
// 车的行走规则
function rookRule(sx: number, sy: number, ex: number, ey: number) {
  if (sx !== ex && sy !== ey) return false
  else if (sx === ex) {
    for (let i = Math.min(sy, ey) + 1; i < Math.max(sy, ey); i++) {
      if (mark[i][sx] !== null) return false
    }
  } else if (sy === ey) {
    for (let i = Math.min(sx, ex) + 1; i < Math.max(sx, ex); i++) {
      if (mark[sy][i] !== null) return false
    }
  }
  return true
}
// 炮的行走规则
function cannonRule(sx: number, sy: number, ex: number, ey: number) {
  let hasBattery = 0 // 只能有一个炮台
  if (mark[sy][sx] !== null && mark[ey][ex] !== null) {
    // 炮吃棋要隔山打牛
    if (sx !== ex && sy !== ey) return false
    else if (sx === ex) {
      for (let i = Math.min(sy, ey) + 1; i < Math.max(sy, ey); i++) {
        if (mark[i][sx] !== null) hasBattery++
      }
      if (hasBattery === 1) return true
      else return false
    } else if (sy === ey) {
      for (let i = Math.min(sx, ex) + 1; i < Math.max(sx, ex); i++) {
        if (mark[sy][i] !== null) hasBattery++
      }
      if (hasBattery === 1) return true
      else return false
    }
  } else {
    if (rookRule(sx, sy, ex, ey)) return true
    // 移动规则同车
    else return false
  }
}
// 马的行走规则
function knight(sx: number, sy: number, ex: number, ey: number) {
  // 对横竖方向的移动分别判断是否有绊马索
  if (Math.abs(sx - ex) === 2 && Math.abs(sy - ey) === 1) {
    // 走横的日
    if (sx > ex && mark[sy][sx - 1] === null) {
      return true
    } else if (sx < ex && mark[sy][sx + 1] === null) {
      return true
    }
    return false
  } else if (Math.abs(sx - ex) === 1 && Math.abs(sy - ey) === 2) {
    // 走竖的日
    if (sy > ey && mark[sy - 1][sx] === null) return true
    else if (sy < ey && mark[sy + 1][sx] === null) return true
    return false
  } else {
    return false
  }
}
// 象和相的行走规则
function bishopRule(sx: number, sy: number, ex: number, ey: number) {
  // 不能过楚河汉界
  if (role === 'w' && ey < 5) return false
  if (role === 'b' && ey > 4) return false
  // 只能走田字形对角线
  if (Math.abs(sx - ex) !== 2 || Math.abs(sy - ey) !== 2) return false
  // 判断是否有绊象脚
  if (sx - ex === 2 && sy - ey === 2) {
    // 向左上角
    if (mark[sy - 1] && mark[sy - 1][sx - 1]) return false
  } else if (sx - ex === 2 && ey - sy === 2) {
    // 向右上角
    if (mark[sy + 1] && mark[sy + 1][sx - 1]) return false
  } else if (ex - sx === 2 && ey - sy === 2) {
    // 向右下角
    if (mark[sy + 1] && mark[sy + 1][sx + 1]) return false
  } else if (ex - sx === 2 && sy - ey === 2) {
    // 向左下角
    if (mark[sy - 1] && mark[sy - 1][sx + 1]) return false
  }
  return true
}
// 士的行走规则
function guard(sx: number, sy: number, ex: number, ey: number) {
  if (role === 'w' && (ex < 3 || ex > 5 || ey < 7)) return false
  if (role === 'b' && (ex < 3 || ex > 5 || ey > 2)) return false
  // 只能走一方格的对角线
  if (Math.abs(sx - ex) !== 1 || Math.abs(sy - ey) !== 1) return false
  return true
}
// 将和帅的行走规则
function kingRule(sx: number, sy: number, ex: number, ey: number) {
  // 将帅狭路相逢直取中军
  if (
    sx === ex &&
    ((role === 'w' && mark[ey][ex] === 'k') || (role === 'b' && mark[ey][ex] === 'K'))
  ) {
    for (let i = Math.min(sy, ey) + 1; i < Math.max(sy, ey); i++) {
      if (mark[i][sx] !== null) return false
    }
    return true
  }
  // 不能离开大本营
  if (role === 'w' && (ex < 3 || ex > 5 || ey < 7)) return false
  if (role === 'b' && (ex < 3 || ex > 5 || ey > 2)) return false
  if (
    (Math.abs(sx - ex) === 1 && Math.abs(sy - ey) === 0) ||
    (Math.abs(sx - ex) === 0 && Math.abs(sy - ey) === 1)
  )
    return true
}
// 兵和卒的行走规则
function pawnRule(sx: number, sy: number, ex: number, ey: number) {
  // 不能往回走
  if (role === 'w' && ey > sy) return false
  if (role === 'b' && ey < sy) return false
  // 过河前只能往前
  if (role === 'w' && sy > 4 && ex !== sx) return false
  if (role === 'b' && sy < 5 && ex !== sx) return false
  // 只能一步步走方格
  if (
    (Math.abs(sx - ex) === 1 && Math.abs(sy - ey) === 0) ||
    (Math.abs(sx - ex) === 0 && Math.abs(sy - ey) === 1)
  )
    return true
}
